// extracted by mini-css-extract-plugin
module.exports = {"label":"_3wa4ssRTCrqvDb80GejBAI","active":"ZkBkEo_bOdwegdBfM6y43"};